

import { municipalityOptions } from '@/config'
import { getMunicipalityNameByCode } from '@/services/municipalities'

/**
 * Realisation
 */
let Realisation = function ({
  ref, data,
}) {

  data = this.commonStructure({ ref, data })
  data.tenant = 'park-n-charge'

  //
  Object.keys(data).forEach(key => {
    this[key] = data[key]
  })
}

Realisation.prototype.generateAddressData = ({ model }) => {
  const CurrentLocation = model.CurrentLocation
  const location = CurrentLocation.Location
  const municipality = getMunicipalityNameByCode({ code: CurrentLocation.Municipality })
  const municipalityName = municipality && `(${municipality})`

  if (location?.StreetName) {
    return `${location.StreetName} ${location.HouseNumber} ${location.HouseNumberSuffix} ${location.CityName} ${municipalityName}`.replace('  ', ' ')
  }
  return ''
}

Realisation.prototype.generateSearchData = ({ model, data }) => {

  let municipalityName = ''
  if (data.Municipality) {
    let municipalityOption = municipalityOptions.find(option => option.value === data.Municipality)
    if (municipalityOption) {
      municipalityName = municipalityOption.text
    }
  }

  return {
    City: model.CurrentLocation ? model.CurrentLocation.Location.CityName: '',
    Municipality: municipalityName,
  }
}


export default Realisation
